import '../../styles/IressWealthTheme.css';
import '../../styles/Layout.css';
import { FormDataHandler } from '../../context/FormHandlingContext';
import { IressCol, IressPanel, IressRow, IressStack } from '@iress-oss/ids-components';
import { FC, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router';
import { Navigation } from '../Navigation/Navigation';
import { useCloseXplanMenuOnInitialLoad } from '../../hooks/UseCloseXplanMenuOnInitialLoad/UseCloseXplanMenuOnInitialLoad';

export const Layout: FC = () => {
    useCloseXplanMenuOnInitialLoad();

    const location = useLocation();
    const isScenarioIndex = useMemo(() => location.pathname === '/', [location]);

    return (
        <IressPanel padding={{ l: 'md', y: 'none' }} background="page" data-testid={'layout'} className="xps-root">
            <FormDataHandler>
                <IressRow gutter="lg">
                    {!isScenarioIndex && (
                        <IressCol alignSelf="stretch" className="xps-navigation" data-testid="menu-column">
                            <Navigation />
                        </IressCol>
                    )}
                    <IressCol data-testid="content-column">
                        <IressPanel background="page" className="xps-content">
                            <IressStack gutter="md" className="xps-sub-content">
                                <Outlet />
                            </IressStack>
                        </IressPanel>
                    </IressCol>
                </IressRow>
            </FormDataHandler>
        </IressPanel>
    );
};
